var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhaseIconL1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 184.56 184.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#766a5a;}.cls-2,.cls-3{fill:#fff;}.cls-3{opacity:0.5;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2",
    "data-name": "Ebene 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 184.56,
    height: 184.56
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M67.7,114.21H93.35v11.34H53V64.41H67.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M128.05,125.55H113.86V80.36L99.92,84.44V73.69l26.83-9.28h1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M125.57,33.37h0a5,5,0,0,1-5-5V0h9.93l0,28.4A5,5,0,0,1,125.57,33.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M144.07,33.37h0a5,5,0,0,1-5-5V0H149l0,28.4A5,5,0,0,1,144.07,33.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M162.57,33.37h0a5,5,0,0,1-5-5V0h9.93l0,28.4A5,5,0,0,1,162.57,33.37Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhaseIconL1);
export default __webpack_public_path__ + "static/media/PhaseIconL1.2fa38c931cf14e64f479e7b143a3ae01.svg";
export { ForwardRef as ReactComponent };